import { List, ListItem, Typography } from "@mui/material";
import { type Control, type FieldValues, type Path } from "react-hook-form";
import { PaperCard } from "@ui-kit/paper-card";
import { ColorPickerInput } from "./color-picker-input";

interface Props<T extends FieldValues> {
  control: Control<T>;
  title?: string;
  fields: { label: string; name: Path<T> }[];
  disabled?: boolean;
}

export const ColorPickers = <T extends FieldValues>({
  control,
  title,
  fields,
  disabled,
}: Props<T>) => {
  return (
    <PaperCard>
      <List
        subheader={
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
        }
      >
        {fields.map((field) => (
          <ListItem key={field.name}>
            <ColorPickerInput
              control={control}
              name={field.name}
              label={field.label}
              disabled={disabled}
            />
          </ListItem>
        ))}
      </List>
    </PaperCard>
  );
};
